import React from 'react';

import InformationMain from "./InformationMain";
import Navigationbar from "./Navigationbar";
import { connect } from "react-redux";

const mapStateToProps = state => {
	return {
		role: state.currentUserReducer.role
	};
}

class CommonTop extends React.Component {
    render()  {
       return( 
           <div>
				<InformationMain history={this.props.history}  />
                { 
                    (this.props.role === 'FOREVER' || this.props.role === 'TRIMIN' || this.props.role === 'COUNTY' || this.props.role === 'TENANT' ) &&
                    <Navigationbar />
                }
                { 
                    (this.props.role === 'USER') &&
                    <div style={{borderTop: '3px solid black', marginTop: 5}}></div>
                }
           </div>
        )
     }
}

export default connect(mapStateToProps)(CommonTop);